export default __webpack_public_path__ + "static/media/instagram-black.aaa207e2.png";